module.exports = __webpack_public_path__ + "img/icon-receipt.495b7aa3.svg";